import * as React from 'react';
import Checkbox from 'src/Checkbox/Checkbox';

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const PendingCheckbox = (props: Props) => {
  const {value, onChange} = props;
  return (
    <div
      className="flex cursor-pointer items-center gap-2 select-none"
      onClick={() => onChange(!value)}
    >
      <Checkbox value={value} onChange={onChange} />
      <span className="text-foreground text-sm">
        Pending
      </span>
    </div>
  );
};
